import React from 'react';

export default class Page8 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <span className="green"><strong>Mostly B</strong> </span>
                                            <p>You are likely to have a very positive approach to employee
                                                engagement and discretionary effort.
                                                Your attitude and management style are likely to ensure that
                                                your team members remain engaged and demonstrate discretionary
                                                effort regularly. Your team members are likely to feel valued by
                                                you and involved in decision making. You could ensure that your
                                                team has consistently good levels of productivity and low
                                                turnover, by engaging with each individual on a regular basis
                                                and
                                                tailoring levels of support to their needs. </p>
                                            <span className="green"><strong>Mostly C</strong> </span>
                                            <p>You appear to prefer a management style that is quite task
                                                focused and your priorities are control,
                                                close monitoring and productivity. You may find that you focus
                                                heavily on team members' 'input' as
                                                well as their 'output'. This style is not usually as closely
                                                linked to employee engagement as more 'people focused'
                                                management styles and, as a result, you may struggle to achieve
                                                engagement from your team. It is also unlikely that they will
                                                give high levels of discretionary effort. You may benefit from
                                                relaxing your control and exploring individual differences and
                                                interests, as a first step to changing your management style.
                                                You could benefit from working to develop greater levels of
                                                trust
                                                in your team members, to allow you to shift to a predominantly
                                                'output' focus. </p>
                                            <span className="green"><strong>Mostly D</strong></span>
                                            <p>Although you appear to have good intentions where encouraging
                                                employee engagement is
                                                concerned, you may find that you are often too busy to properly
                                                execute your ideas. As a result, you may provide straightforward
                                                solutions that appear helpful on the surface, as opposed to
                                                exploring what different individuals really need from you. You
                                                may benefit from allocating more time to people management to
                                                enable you to focus on individual needs more closely and on a
                                                more informal basis. It is often the informal occurrences that
                                                can really make a difference to
                                                engagement and discretionary effort. </p>

                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>NEXT STEPS
                                            </div>

                                            <p>You should now be able to see the value of empowering and
                                                motivating people to achieve broader
                                                organisational goals. Consider the following suggestions for
                                                practical next steps:</p>
                                            <div className="border_subtitle">Gain feedback</div>
                                            <p>Consider seeking feedback from your team/employees about how they
                                                perceive you. This may
                                                need to be confidential to encourage them to share their views.
                                                Ask them to be honest and open and review your approach as fully
                                                as possible. Check if there are any flaws or different
                                                opportunities they identify which you can alter or work on. </p>
                                            <div className="border_subtitle">Meet up with your team</div>
                                            <p>You could meet with your team on an individual or group level, to
                                                discuss what more you could do
                                                for them: do they have enough of your time, do you speak with
                                                them frequently enough, could you
                                                give them more support? </p>
                                            <p>Ensure you make time to get to know each of your team members
                                                individually - seek to
                                                understand what makes them tick, what they are interested in,
                                                what they think about their work. By understanding individuals,
                                                you can tailor your approach to their needs; for example,
                                                different
                                                people like to receive recognition in different ways. </p>
                                            <div className="border_subtitle">Use the exercises in this tool
                                            </div>
                                            <p>To explore whether your management style is likely to encourage
                                                employee engagement and
                                                discretionary effort, do the quick and simple questionnaire
                                                provided above. Use the output from the questionnaire to start
                                                to understand the impact you have on your team/employees. Try
                                                this
                                                approach and see how it works for you.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page9')}
                                                     className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}